export default __webpack_public_path__ + "static/media/prev_hover.ad298d86.svg";